import { JobEntityType, JobWithShare } from "@/lib/supabase/supabaseTypes";
import { SquareArrowOutUpRightIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { SheetHeaderProps } from "@/dentlab/src/store/Sheets/sheet-provider/sheetRegistry";
import { Tooltip } from "@mui/material";
import { PinJob } from "@/dentlab/src/pages/job-page/pin-job.component";

export interface JobSheetActionsProps {
	job: JobEntityType | null;
}

export const JobSheetActions: React.FC<
	JobSheetActionsProps & SheetHeaderProps
> = ({ sheetKey, job, className }) => {
	const navigate = useNavigate();
	return (
		<>
			{job && <PinJob job={job as JobWithShare} />}
			<button
				onClick={() =>
					navigate(`/client/${job?.client_id}/job/${job?.id}`)
				}
				className={className}
			>
				<Tooltip title="Zum Auftrag">
					<SquareArrowOutUpRightIcon className="w-5 h-5" />
				</Tooltip>
			</button>
		</>
	);
};
